import Cookies from 'js-cookie'
export default {
  namespaced: true,
  state: () => ({
    nextUrl: Cookies.get('EDU_GLOBAL_NEXT_URL'),
    footerVisible: false,
  }),
  mutations: {
    nextUrl(state, value) {
      Cookies.set('EDU_GLOBAL_NEXT_URL', value)
      state.nextUrl = value

    },
    footerVisible(state, value) {
      state.footerVisible = value
    },
  },
  getters: {
    nextUrl(state) {
      return state.nextUrl
    },
    footerVisible(state) {
      return state.footerVisible
    },
  },
}
